/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, Dispatch } from 'react';
import { CabsLandingStatesType } from './pages/CabsLandingPage/cabsLandingPageState';

export const CabsLandingContext = createContext<CabsLandingStatesType>({
  airport: null,
  airportCity: null,
  travelFor: '',
  widget: null,
  sourceCity: null,
  destinationCity: null,
  rentalCity: null,
  selectedDeptDate: new Date(),
  selectedReturnDate: new Date(),
  selectedHrPackage: null,
  airportRideNow: false,
  stopOvers: [],
  activeStopOver: null,
  errorMessage: null,
  packages: [],
  dropWidgetOpen: false,
  trackTemplateEvent: (eventWithValToTrack: string) => {}
});
export const CabsLandingDispatchContext = createContext<Dispatch<any> | null>(
  null
);
